import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../../../shared/services/authentication/authentication.service";
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {first} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

    resetForm: FormGroup;
    token: string;
    submitted = false;
    returnUrl: string;
    showSpinner: boolean;
    userConfirmation: number = 0;
    loading = false;

    constructor(private authenticationService: AuthenticationService,
                private route: ActivatedRoute,
                private router: Router,
                private toastr: ToastrService,
                private formBuilder: FormBuilder,
                private translate: TranslateService) {
    }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();

        this.resetForm = this.formBuilder.group({
            new_password: ['', [Validators.required, Validators.minLength(5)]],
            confirm_password: ['', [Validators.required, Validators.minLength(5)]]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.route.queryParams.subscribe(params => {

            if (params.token !== undefined && params.token !== "") {
                this.token = params.token;
                this.checkConfirmationToken();
            } else {
                this.router.navigate([this.returnUrl]);
            }

        })

    }

    get f() {
        return this.resetForm.controls;
    }

    onSubmit() {

        this.submitted = true;

        if (this.f.new_password.value.trim() !== this.f.confirm_password.value.trim()) {
            this.toastr.error(this.translate.instant('PASSWORD_RESET_DIFFERENT'), this.translate.instant('ERROR'));

        }

        if (this.f.new_password.errors) {
            if (this.f.new_password.errors.required) this.toastr.error(this.translate.instant('NEW_PASSWORD_FORM_ERROR_LENGTH'), this.translate.instant('ERROR'));
            if (this.f.new_password.errors.minlength) this.toastr.error(this.translate.instant('NEW_PASSWORD_FORM_ERROR_REQUIRED'), this.translate.instant('ERROR'));

        }
        if (this.f.confirm_password.errors) {
            if (this.f.confirm_password.errors.required) this.toastr.error(this.translate.instant('CONFIRM_PASSWORD_FORM_ERROR_LENGTH'), this.translate.instant('ERROR'));
            if (this.f.confirm_password.errors.minlength) this.toastr.error(this.translate.instant('CONFIRM_PASSWORD_FORM_ERROR_REQUIRED'), this.translate.instant('ERROR'));

        }

        if (this.userConfirmation === 0) this.toastr.error(this.translate.instant('PASSWORD_ALREADY_RESET'), this.translate.instant('ERROR'));

        // stop here if form is invalid
        if (this.resetForm.invalid || this.userConfirmation === 0 || (this.f.new_password.value.trim() !== this.f.confirm_password.value.trim())) {
            return;
        }

        this.loading = true;
        this.authenticationService.userResetPassword(this.userConfirmation, this.token, this.f.new_password.value.trim(), this.f.confirm_password.value.trim())
            .pipe(first())
            .subscribe(
                data => {
                    this.loading = false;
                    let t = this.toastr.success(this.translate.instant('PASSWORD_RESET_SUCCESS'), this.translate.instant('SUCCESS'));
                    t.onHidden.subscribe(() => {
                        this.router.navigate([this.returnUrl]);
                    });
                },
                error => {
                    this.loading = false;
                });
    }


    private checkConfirmationToken() {
        this.showSpinner = true;
        this.authenticationService.checkConfirmationToken(this.token).subscribe((data: any) => {
                this.showSpinner = false;
                this.userConfirmation = data.id;
            },
            error => {
                this.showSpinner = false;
            })

    }

}
